import { OnInit } from '@angular/core';

import { Fcapp } from 'fccore2';
import { Sysapplinks, Sysappfldgroup } from 'fccore2';
import { SystemBusiness } from 'fccore2';
import { CommonService } from 'fccore2';
import { FcModalConfig } from './business/fcmodel.business';
import { FcEvent } from './business/fcevent.event';
import { ParentBusiness } from 'fccore2';
import { Fcomponent } from './f';
export abstract class GrandComponent extends Fcomponent implements OnInit {
  moduleId: string = '';
  /** è·¯ç±åæ° */
  routerParam: any;
  /** ç¨æ·ä¿¡æ¯ */
  userInfo: any;
  /** å½åä¸»åºç¨id */
  appId: string = '';
  /** å½åä¸»åºç¨ */
  mainApp: Fcapp;
  /** å³ç³» */
  mainLinks: Sysapplinks[];
  /** å­æ®µåç» */
  mainFldGroups: Sysappfldgroup[];
  /** å½åä¸»å¯¹è±¡è·åæ¹å¼,é»è®¤ä¸º */
  getMainObjWay: number = GetMainObjWay.cache;
  /**
   * å½æ¨¡ååäº§åidå­å¨æ¶ï¼ååå§åç¸å³çåå®¹ï¼åå«æ¨¡åæè¿°ï¼æ¨¡åå¯¹åºçå±æ§åäºä»¶
   * @param pid äº§åid
   * @param aid æ¨¡åid
   */
  constructor(pid?: string, aid?: string) {
    super();
    /** åå§åç¨æ·ä¿¡æ¯ */
    this.userInfo = SystemBusiness.getUserinfo();
    /** æ ¡éªæ¯å¦å­å¨äº§åidåæ¨¡åid */
    if (pid && pid.length !== 0 && aid && aid.length !== 0) {
      /** åå§åäº§åid */
      this.moduleId = pid;
      /** åå§ååæ°æ®id */
      this.appId = aid;
      /** åå§ååæ°æ® */
      this.mainApp = ParentBusiness.appService.getAppById(this.appId);
      if (this.mainApp) {
        /** åå§åå³ç³»  */
        this.mainLinks = this.mainApp.SYSAPPLINKS;
        /** åå§åå­æ®µåç»  */
        this.mainFldGroups = this.mainApp.SYSAPPFLDGROUP;
        this.routerParam = SystemBusiness.activatedRoute.snapshot.queryParams;
        if (this.routerParam === undefined) {
          this.routerParam = SystemBusiness.activatedRoute.snapshot.params;
        }
        /** åå§åå­ç±»  */
        this._init();
      } else {
        ParentBusiness.appService
          .findAppByAid(aid, this.moduleId)
          .subscribe(result => {
            if (result.CODE === '0') {
              const sApp = result.DATA;
              if (sApp && sApp[aid]) {
                ParentBusiness.appService.apps[aid] = sApp[aid];
                /** åå§ååæ°æ® */
                this.mainApp = ParentBusiness.appService.getAppById(this.appId);
                if (this.mainApp) {
                  /** åå§åå³ç³» */
                  this.mainLinks = this.mainApp.SYSAPPLINKS;
                  /** åå§åå­æ®µåç» */
                  this.mainFldGroups = this.mainApp.SYSAPPFLDGROUP;
                  this.routerParam =
                    SystemBusiness.activatedRoute.snapshot.params;
                  /** åå§åå­ç±» */
                  this._init();
                }
              }
            }
          });
      }
    } else {
      this.routerParam = SystemBusiness.activatedRoute.snapshot.params;
      /** åå§åå­ç±» */
      this._init();
    }
  }
  /**
   * åå§åå­å¨
   */
  abstract _init(): void;
  /**
   * å½çé¢æ¾ç¤ºçæ¶å
   *
   */
  ngOnInit(): void {}
  /**
   * èªå®ä¹äºä»¶åç§°ï¼ææèªå®ä¹äºä»¶çå¥å£
   * @param eventName äºä»¶åç§°
   * @param param åæ°
   */
  abstract event(eventName: string, param: any): void;
  /**
   * è·åè·¯ç±å¯¼èª
   * @param exp Listï¼åè¡¨ï¼Edit:ç¼è¾:Detailï¼è¯¦æ
   */
  getRouteUrl(exp: string): string {
    return this.getUrl(this.moduleId, this.appId, exp);
  }
  /**
   * è·åè·¯ç±å¯¼èª
   * @param exp Listï¼åè¡¨ï¼Edit:ç¼è¾:Detailï¼è¯¦æ
   */
  getUrl(moduleId: string, appId: string, exp: string): string {
    return (
      '/' + moduleId.toLocaleLowerCase() + '/' + appId.toLocaleLowerCase() + exp
    );
  }
  /**
   * è·³è½¬è·¯ç±å¼å¶å®é¡µé¢
   * @param router è·¯ç±ç®å½
   * @param param è·¯ç±åæ°
   * @returns è¿åpromise
   */
  navigate(url: string, param?: any): Promise<any> {
    if (param) {
      return SystemBusiness.navigate([url], { queryParams: param });
    } else {
      return SystemBusiness.navigate([url]);
    }
  }

  /**
   * è·åç¡®è®¤å¼¹çªï¼éè¦ä¼ ç¹okåçåè°å½æ°åç¹åæ¶åçåè°å½æ°
   * @param content æç¤ºåå®¹
   * @param title æ é¢
   * @param ok ç¡®è®¤æ¹æ³
   * @param cancel åæ¶çæ¹æ³
   */
  confirm(content: string, title: string, ok: () => {}, cancel: () => {}): void {
    const modal: FcModalConfig = {
      title,
      content,
      okFunc: () => ok(),
      cancelFunc: () => cancel()
    };
    CommonService.event(FcEvent.fcmodal.confirm, modal);

    //  /** ParentBusiness.msgService.confirm(content, ok, cancel);*/
  }
  /**
   * é»æ­¢åæ³¡
   */
  stopPropagation(event: any): void {
    event.stopPropagation();
    event.preventDefault();
  }
}

/**
 * ä¿®æ¹å¯¹è±¡çè·åç­ç¥ï¼é»è®¤ä¸ºcacheæ¹å¼è·åæ°æ®ï¼asyncä¸ºä»è¿ç¨è·åæ°æ®æ¹å¼
 */
export enum GetMainObjWay {
  'cache',
  'async'
}
